<span *ngIf="varianceToggleAction" class="variance-toggle-wrapper">
    <span class="variance-pill-label">Variance</span>
  <mat-slide-toggle (change)="toggleVariance(varianceToggleAction)"
  [checked]="varianceToggleAction.display"></mat-slide-toggle>
  </span>
